import { useMutation } from "react-query";
import { getCalculatedDueDate, getSLACounts } from "../lib/shipmentData";
import { DATE_FNS_SHORT_DATE_FORMAT } from "shared/constants";
import * as notify from "shared/notify";
import { format } from "date-fns";

export const useCalculateDueDate = () => {
    return useMutation(async ({ startDate, isRush, shipmentReceiveDate, turnAroundDays = "0", rushDays, cxHCompany, clientsCxH }) => {
        let dueDateParams = {
            shipmentReceiveDate: format(new Date(shipmentReceiveDate), DATE_FNS_SHORT_DATE_FORMAT),
        };

        if (parseInt(turnAroundDays, 10) < 0) {
            notify.error("Turn Around Time can not be negative");

            return;
        }

        dueDateParams = isRush ? { rushDays: turnAroundDays || "0", ...dueDateParams } : { turnAroundDays: turnAroundDays || "0", ...dueDateParams };

        const { dueDate } = await getCalculatedDueDate(dueDateParams);
        const cxhClient = cxHCompany ? clientsCxH.find((c) => c.value === cxHCompany) : null;
        const sla_counts = cxhClient ? await getSLACounts(cxhClient.id, format(new Date(shipmentReceiveDate), DATE_FNS_SHORT_DATE_FORMAT)) : {};

        return {
            dueDate: format(new Date(dueDate), DATE_FNS_SHORT_DATE_FORMAT),
            sla_counts,
        };
    });
};
